import clsx from 'clsx';

export const createMedicalPrescription = (data) => ({
  method: 'POST',
  url: `/medical-prescriptions`,
  data,
});

export const updateMedicalPrescription = (medicalPrescriptionId, data) => ({
  method: 'PUT',
  url: `/medical-prescriptions/${medicalPrescriptionId}`,
  data,
});

export const deleteMedicalPrescription = (medicalPrescriptionId) => ({
  method: 'DELETE',
  url: `/medical-prescriptions/${medicalPrescriptionId}`
});

export const fetchMedicalPrescription = (medicalPrescriptionId) => ({
  method: 'GET',
  url: `/medical-prescriptions/${medicalPrescriptionId}`,
});

export const fetchMedicalPrescriptionList = ({ contractId }) => ({
  method: 'GET',
  url:  clsx(
    '/medical-prescriptions?',
    contractId && `contractId=${contractId}`,
  ).split(' ').join('&'),
});

export const supplyMedicine = (medicalPrescriptionId, medicineId, data) => ({
  method: 'POST',
  url: `/medical-prescriptions/${medicalPrescriptionId}/medicines/${medicineId}`,
  data,
});
